<div class="mon-container flex flex-col justify-center items-center">
  <img class="logo" src="assets/images/white_text_logo.png" alt="">
  <div class="info-card">
    <div class="flex flex-col items-start justify-around md:flex-row md:items-center h-[120px]">
      <a href="Tel:+1-825-436-2133" class="flex  text-white h6-responsive lh-24px">
        <img src="assets/images/phone2.png" alt="phone">
        <span class="ml-2">+1-825-436-2133</span>
      </a>
      <hr class="mx-0 md:mx-8 w-full">
      <p class="flex text-white h6-responsive lh-24px">
        <img src="assets/images/place.png" alt="place">
        <span class="ml-2">Unit 104, 9271 34 Ave NW, Edmonton AB T6E 5T5</span>
      </p>
    </div>

    <div class="icons">
      <a href="https://www.facebook.com/monisferfx/" target="_blank">
        <img src="assets/images/facebook.png" alt="facebook">
      </a>
      <a href="https://t.me/monisferFX" target="_blank">
        <img src="assets/images/telegram2.png" alt="telegram">
      </a>
      <a href="https://www.instagram.com/monisferfx/?hl=en" target="_blank">
        <img src="assets/images/instagram.png" alt="instagram">
      </a>
    </div>
  </div>

  <div class="made-by-trustply flex justify-between mt-20 w-full px-3">
    <span class="h6-responsive text-white">Made with ❤️ in Edmonton by </span>
    <hr>
    <a href="https://trustply.com/">
      <img class="trustply-logo" src="assets/images/trustply_logo.png" alt="trustply logo">
    </a>
  </div>
</div>